import styled from 'styled-components'
import useTranslation from 'next-translate/useTranslation'
import { useEffect, useRef, useState } from 'react'

import useReveal from 'hooks/useReveal'
import device from 'utils/device'
import Download from 'components/Download'
import Reveal from 'components/Reveal'
import useInterval from 'hooks/useInterval'

export default function Environment({cta, buttons}) {
    const { t } = useTranslation('home')

    const ref = useRef()
    const isVisible = useReveal(ref, { threshold: 0.5 })
    const [delay, setDelay] = useState(null)
    const started = useRef(false)

    const [number, setNumber] = useState(0);

    useInterval(() => {
        if (number < 90) {
            setNumber(number + 1);
        }
    }, delay)

    useEffect(() => {
        let timer
        if (isVisible && !started.current) {
            started.current = true
            timer = setTimeout(() => setDelay(2000 / 100), 800); // Start after 5 seconds

            // timer2 = setTimeout(() => {
            //     // let path = document.querySelector('.circle');
            //     // path.setAttribute("stroke-dasharray", "1195, 1195");  // 2*PI*189 = approx. 1195
            // }, 1000);
        }

        
        
        return () => {
            timer && clearTimeout(timer); // Clean up timeout
        }
    }, [isVisible])

    // useEffect(() => {
    //     // Set stroke-dasharray equal to the circumference of the circle (2πr, r = 189 in this case)
    //     // let length = 2 * Math.PI * 189;

    //     // // Set the CSS variables
    //     // console.log(length)
    //     // path.style.setProperty('stroke-width', length);
    //     setTimeout(() => {
    //         let path = document.querySelector('.circle');
    //         path.setAttribute("stroke-dasharray", "1195, 1195");  // 2*PI*189 = approx. 1195
    //     }, 1000);
    // })

    return (
        <Reveal>
            <Container ref={ref}>
                <div>
                    <Reveal delay="1">
                        <h2 className="h2">{t('home_environment_name')}</h2>
                    </Reveal>
                    <Reveal delay="2">
                    <p>
                            <strong>
                                {t('home_environment_slogan')}
                                <svg viewBox="0 0 164.613 10.102">
                                    <path
                                        d="M1.1 9.003S85.152.089 163.6 1.08"
                                        fill="none"
                                        stroke="#c8fe59"
                                        strokeLinecap="round"
                                        strokeMiterlimit="10"
                                        strokeWidth="2"
                                        className={`${isVisible ? 'animate' : ''}`}
                                    />
                                </svg>
                            </strong>
                        </p>
                    </Reveal>
                    <Reveal delay="3">
                        {cta ? cta : buttons ? buttons() : <Download />}
                    </Reveal>
                    <Credit>
                        <Reveal delay="4">
                        {t('home_environment_credit')}
                        </Reveal>
                    </Credit>
                </div>
                <Reveal delay="4">
                    <Circ>
                        <Perc>{number}%</Perc>
                        <svg id="env" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 420 420">
                            <path fill="#fff" data-name="Path 63841" d="M209.933 0v36l-2.285.015-.462-36Zm0 0 4.37.045-.736 35.992-3.634-.037Zm15.282.548 4.359.359-3.328 35.846-3.616-.3ZM240.433 2.2l4.324.676-5.93 35.508-3.581-.56Zm15.064 2.759 4.265.991-8.517 34.98-3.529-.82Zm14.825 3.857 4.181 1.3-11.061 34.261-3.459-1.077Zm14.5 4.935 4.073 1.6-13.542 33.361-3.371-1.328Zm14.1 5.985 3.943 1.9-15.949 32.273-3.265-1.571Zm13.621 7 3.793 2.18-18.264 31.023-3.139-1.806Zm13.07 7.972 3.623 2.45-20.474 29.612-3-2.031Zm12.452 8.9 3.435 2.706-22.567 28.048-2.849-2.244Zm-266.819 8.7 23.787 27.024-2.7 2.424L67.994 55.23Zm278.587 1.079 3.23 2.948-24.539 26.337-2.679-2.445Zm-289.7 9.439 25.679 25.231-2.515 2.613-26.2-24.694Zm300.735 1.164 3.008 3.174-26.385 24.492-2.5-2.633ZM49.812 74.122 77.25 97.427l-2.317 2.789-27.918-22.732Zm321.291 1.244 2.77 3.384-28.09 22.515-2.3-2.806ZM40.333 86.138l29.058 21.253-2.11 2.949-29.492-20.646Zm340.153 1.317 2.518 3.576-29.65 20.417-2.087-2.965ZM31.753 98.813 62.278 117.9l-1.89 3.093-30.916-18.447ZM388.97 100.2l2.252 3.751-31.058 18.2-1.866-3.108ZM24.115 112.082 55.95 128.89l-1.658 3.222-32.18-16.139Zm372.39 1.442 1.973 3.907-32.3 15.888-1.633-3.235Zm-379.04 12.355 32.98 14.433-1.417 3.333-33.276-13.738Zm385.583 1.493 1.682 4.042-33.381 13.479-1.392-3.345ZM11.842 140.128l33.95 11.972-1.169 3.428-34.19-11.257Zm396.716 1.537 1.381 4.155-34.281 10.992-1.142-3.437ZM7.281 154.752l34.738 9.45-.914 3.506-34.928-8.719Zm405.725 1.572 1.072 4.245-35 8.446-.887-3.512ZM3.806 169.67l35.337 6.877-.655 3.565-35.473-6.136Zm412.56 1.6.758 4.31-35.52 5.861-.627-3.569ZM1.433 184.8l35.745 4.279-.394 3.606L.958 189.15Zm417.19 1.615.441 4.352-35.852 3.259-.366-3.608ZM.165 200.046l35.961 1.68-.132 3.628-35.988-.941Zm419.605 1.622.126 4.368-35.994.667-.1-3.63ZM35.988 214.435l.128 3.629L.153 219.7l-.154-4.369Zm347.85 1.352 35.981 1.174-.187 4.365-35.949-1.913ZM36.762 227.109l.389 3.606-35.75 4.236-.468-4.351Zm346.205 1.343 35.8 3.769-.5 4.344-35.716-4.513Zm-344.515 11.23.651 3.565-35.345 6.834-.786-4.306Zm342.729 1.328 35.432 6.369-.819 4.3-35.291-7.109ZM41.054 252.089l.91 3.507L7.215 265l-1.1-4.238Zm337.428 1.311 34.87 8.949-1.133 4.228-34.675-9.679ZM44.558 264.27l1.165 3.43-33.965 11.933-1.408-4.146Zm330.325 1.279 34.119 11.485-1.44 4.134-33.87-12.2ZM48.948 276.161l1.413 3.335-33 14.393-1.708-4.03Zm321.453 1.245 33.184 13.958-1.739 4.017-32.884-14.65Zm-316.2 10.3 1.654 3.224-31.858 16.763-2-3.893Zm310.862 1.2 32.073 16.35-2.028 3.878-31.725-17.016Zm-304.782 9.923 1.886 3.1-30.548 19.044-2.276-3.736Zm298.611 1.156 30.794 18.647-2.3 3.718-30.4-19.284Zm-291.731 9.5 2.107 2.951-29.083 21.222-2.541-3.56Zm284.772 1.105 29.356 20.838-2.569 3.54-28.917-21.443Zm-277.134 9.031 2.316 2.791-27.467 23.273-2.792-3.366Zm269.414 1.044 27.767 22.913-2.818 3.344-27.286-23.483Zm-261.06 8.511 2.512 2.617-25.709 25.2-3.028-3.154Zm252.632.979 26.034 24.864-3.053 3.131-25.514-25.4ZM92.178 338.1l2.695 2.428-23.817 27-3.249-2.928Zm234.514.909 24.166 26.684-3.271 2.9-23.608-27.178Zm-224.867 7.341 2.863 2.226-21.8 28.651-3.453-2.684Zm215.157.835 22.169 28.365-3.474 2.657-21.575-28.819Zm-204.939 6.69 3.017 2.011-19.659 30.159-3.64-2.427Zm194.664.755 20.05 29.9-3.658 2.4-19.424-30.31Zm-183.93 6 3.156 1.79-17.41 31.512-3.808-2.156Zm173.144.672 17.819 31.281-3.824 2.126-17.163-31.642Zm-161.95 5.286 3.275 1.55-15.057 32.7-3.956-1.868Zm150.709.584 15.486 32.5-3.971 1.841-14.8-32.816Zm-139.112 4.536 3.379 1.305-12.614 33.721-4.084-1.578Zm127.476.494 13.063 33.546-4.1 1.545-12.356-33.813Zm-115.537 3.762 3.465 1.054-10.11 34.551-4.189-1.274Zm103.565.4 10.561 34.42-4.2 1.241-9.84-34.629Zm-91.346 2.967 3.534.8-7.547 35.2-4.27-.963Zm79.1.305 8.01 35.1-4.277.929-7.273-35.258Zm-66.663 2.164 3.585.536-4.954 35.658-4.328-.647Zm54.208.208 5.42 35.59-4.331.613-4.677-35.695Zm-41.616 1.341 3.618.275-2.353 35.923-4.36-.331Zm29.012.111 2.819 35.889-4.361.3-2.077-35.94Zm-16.328.523 2.494.017h1.143l.231 36h-1.374l-3-.021Z"/>
                            <path className={`circle ${isVisible ? 'animate' : ''}`} strokeWidth="44" strokeDasharray="0, 100" d="M210 21
                                    a 189 189 0 0 1 0 378
                                    a 189 189 0 0 1 0 -378"/>
                            <path fill="#fff" data-name="Path 63841" d="M209.933 0v36l-2.285.015-.462-36Zm0 0 4.37.045-.736 35.992-3.634-.037Zm-13.662.438 2.31 35.926-3.618.27-3.052-35.87Zm28.944.11 4.359.359-3.328 35.846-3.616-.3Zm-44.17 1.425 4.911 35.663-3.585.532-5.654-35.553Zm59.388.227 4.324.676-5.93 35.508-3.581-.56Zm-74.471 2.414 7.5 35.209-3.529.793-8.241-35.044Zm89.535.345 4.265.991-8.517 34.98-3.529-.82Zm-104.389 3.4 10.068 34.564-3.467 1.049-10.793-34.348Zm119.214.461 4.181 1.3-11.061 34.257-3.459-1.077Zm-133.757 4.358 12.578 33.731-3.381 1.3L132.48 14.75Zm148.258.574 4.073 1.6-13.543 33.36-3.371-1.328Zm-162.4 5.3 15.01 32.719-3.277 1.546-15.7-32.4Zm176.5.685 3.943 1.9-15.95 32.272-3.265-1.571Zm-190.178 6.209 17.37 31.533-3.156 1.782L104.933 28.1Zm203.8.791 3.793 2.18-18.266 31.022-3.139-1.806Zm-216.93 7.08L115.233 64l-3.019 2.008-20.243-29.769Zm230 .892 3.623 2.45-20.476 29.611-3-2.031ZM83.093 42.62l21.762 28.68-2.866 2.22L79.633 45.3Zm254.973.988 3.435 2.706-22.568 28.048-2.849-2.244Zm-266.819 8.7 23.786 27.024-2.7 2.424L67.994 55.23Zm278.586 1.079 3.23 2.948-24.539 26.337-2.679-2.445Zm-289.7 9.439 25.679 25.231-2.515 2.613-26.2-24.694Zm300.735 1.164 3.008 3.174-26.385 24.492-2.5-2.633ZM49.812 74.122 77.25 97.427l-2.317 2.789-27.918-22.732Zm321.291 1.244 2.77 3.384-28.09 22.515-2.3-2.806ZM40.333 86.138l29.058 21.253-2.11 2.949-29.492-20.646Zm340.153 1.317 2.518 3.576-29.65 20.417-2.087-2.965ZM31.753 98.813 62.278 117.9l-1.89 3.093-30.916-18.447ZM388.97 100.2l2.252 3.751-31.058 18.2-1.866-3.108ZM24.115 112.082 55.95 128.89l-1.658 3.222-32.18-16.139Zm372.39 1.442 1.973 3.907-32.3 15.888-1.633-3.235Zm-379.04 12.355 32.98 14.433-1.417 3.333-33.276-13.738Zm385.583 1.493 1.682 4.042-33.381 13.479-1.392-3.345ZM11.842 140.128l33.95 11.972-1.169 3.428-34.19-11.257Zm396.716 1.537 1.381 4.155-34.281 10.992-1.142-3.437ZM7.281 154.752l34.738 9.45-.914 3.506-34.928-8.719Zm405.725 1.572 1.072 4.245-35 8.446-.887-3.512ZM3.806 169.67l35.337 6.877-.655 3.565-35.473-6.136Zm412.56 1.6.758 4.31-35.52 5.861-.627-3.569ZM1.433 184.8l35.745 4.279-.394 3.606L.958 189.15Zm417.19 1.615.441 4.352-35.852 3.259-.366-3.608ZM.165 200.046l35.961 1.68-.132 3.628-35.988-.941Zm419.605 1.622.126 4.368-35.994.667-.1-3.63ZM35.988 214.435l.128 3.629L.153 219.7l-.154-4.369Zm347.85 1.352 35.981 1.174-.187 4.365-35.949-1.913ZM36.762 227.109l.389 3.606-35.75 4.236-.468-4.351Zm346.205 1.343 35.8 3.769-.5 4.344-35.716-4.513Zm-344.515 11.23.651 3.565-35.345 6.834-.786-4.306Zm342.729 1.328 35.432 6.369-.819 4.3-35.291-7.109ZM41.054 252.089l.91 3.507L7.215 265l-1.1-4.238Zm337.428 1.311 34.87 8.949-1.133 4.228-34.675-9.679ZM44.558 264.27l1.165 3.43-33.965 11.933-1.408-4.146Zm330.325 1.279 34.119 11.485-1.44 4.134-33.87-12.2ZM48.948 276.161l1.413 3.335-33 14.393-1.708-4.03Zm321.453 1.245 33.184 13.958-1.739 4.017-32.884-14.65Zm-316.2 10.3 1.654 3.224-31.858 16.763-2-3.893Zm310.862 1.2 32.073 16.35-2.028 3.878-31.725-17.016Zm-304.782 9.923 1.886 3.1-30.548 19.044-2.276-3.736Zm298.611 1.156 30.794 18.647-2.3 3.718-30.4-19.284Zm-291.731 9.5 2.107 2.951-29.083 21.222-2.541-3.56Zm284.772 1.105 29.356 20.838-2.569 3.54-28.917-21.443Zm-277.134 9.031 2.316 2.791-27.467 23.273-2.792-3.366Zm269.414 1.044 27.767 22.913-2.818 3.344-27.286-23.483Zm-261.06 8.511 2.512 2.617-25.709 25.2-3.028-3.154Zm252.632.979 26.034 24.864-3.053 3.131-25.514-25.4ZM92.178 338.1l2.695 2.428-23.817 27-3.249-2.928Zm234.514.909 24.166 26.684-3.271 2.9-23.608-27.178Zm-224.867 7.341 2.863 2.226-21.8 28.651-3.453-2.684Zm215.157.835 22.169 28.365-3.474 2.657-21.575-28.819Zm-204.939 6.69 3.017 2.011-19.659 30.159-3.64-2.427Zm194.664.755 20.05 29.9-3.658 2.4-19.424-30.31Zm-183.93 6 3.156 1.79-17.41 31.512-3.808-2.156Zm173.144.672 17.819 31.281-3.824 2.126-17.163-31.642Zm-161.95 5.286 3.275 1.55-15.057 32.7-3.956-1.868Zm150.709.584 15.486 32.5-3.971 1.841-14.8-32.816Zm-139.112 4.536 3.379 1.305-12.614 33.721-4.084-1.578Zm127.476.494 13.063 33.546-4.1 1.545-12.356-33.813Zm-115.537 3.762 3.465 1.054-10.11 34.551-4.189-1.274Zm103.565.4 10.561 34.42-4.2 1.241-9.84-34.629Zm-91.346 2.967 3.534.8-7.547 35.2-4.27-.963Zm79.1.305 8.01 35.1-4.277.929-7.273-35.258Zm-66.663 2.164 3.585.536-4.954 35.658-4.328-.647Zm54.208.208 5.42 35.59-4.331.613-4.677-35.695Zm-41.616 1.341 3.618.275-2.353 35.923-4.36-.331Zm29.012.111 2.819 35.889-4.361.3-2.077-35.94Zm-16.328.523 2.494.017h1.143l.231 36h-1.374l-3-.021Z" opacity=".16"/>
                        </svg> 
                    </Circ>
                </Reveal>     
            </Container>
        </Reveal>
    )
}


const Container = styled.div`
    width: var(--wrap);
    margin: 0 auto;
    position: relative;
    background: var(--color-blue);
    border-radius: 0.24rem;
    padding: 0.62rem 0.85rem 0.62rem 1.02rem;
    display: flex;
    align-items: center;
    .circle {
        fill: none;
        stroke: var(--color-blue);
        transform: scaleX(-1) rotate(1deg);
        transform-origin: 50% 50%;
        stroke-dasharray: 1195 1195;
        &.animate {
            animation: progress 2s 0.8s ease-in-out forwards;
        }
    }
    @keyframes progress {
        from {
            stroke-dasharray: 1195 1195;
        }
        to {
            stroke-dasharray: 0 1195;
        }
    }
    @keyframes draw {
        0% {
          stroke-dasharray: 300, 300;
          stroke-dashoffset: 300;
        }
        100% {
          stroke-dasharray: 300, 300;
          stroke-dashoffset: 0;
        }
      }
    * {
        color: #fff;
    }
    > div > div > svg {
        width: 4.2rem;
        height: 4.2rem;
        flex-shrink: 0;
    }
    h2 {
        margin-bottom: 0.16rem;
    }
    p {
        margin: 0;
    }
    strong {
        position: relative;
        margin-bottom: 0.44rem;
        display: inline-block;
        svg {
            width: 1.64613rem;
            height: 0.101rem;
            position: absolute;
            top: 100%;
            left: 50%;
            margin-top: 0.04rem;
            margin-left: -0.81rem;
            stroke-dasharray: 300, 300;
          stroke-dashoffset: 300;
            .animate {
                animation: draw 800ms 1200ms ease-in-out forwards;
            }
        }
    }
    ${device.mobile} {
       flex-direction: column-reverse;
       width: auto;
       margin: 0 0.16rem;
       padding: 0.36rem 0.24rem 0.24rem 0.24rem;
       > div > div > svg {
        width: 2.96rem;
        height: 2.96rem;
       }
    }
`

const Credit = styled.div`
    position: absolute;
    bottom: 0.36rem;
    opacity: 0.48;
    font-size: 0.14rem;
    ${device.mobile} {
        position: static;
        font-size: 0.13rem;
        margin-top: 0.36rem;
    }
`

const Circ = styled.div`
    position: relative;
    ${device.mobile} {
        margin-bottom: 0.36rem;
    }
`

const Perc = styled.div`
    position: absolute;
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    font-size: 0.92rem;
    font-family: 'Recoleta';
    ${device.mobile} {
        font-size: 0.64rem;
    }
`